import { UsersReducer, USERS_INITIAL_STATE } from '../reducers'
import { useCallback, useReducer } from 'react'
import { useUsersCalls } from './users-calls.hook'

// Traduce los nombres de filtro usados internamente en el front (en español,
// heredados del formulario) a los nombres definitivos que espera la lambda
// `list-users` (GET /v1/users).
const buildUsersQueryParams = (search = {}) => {
  const params = {}
  if (search._search) params.search = search._search
  if (search.estado) params.status = search.estado
  if (search.rol) params.role = search.rol
  const toIso = (value) => (value instanceof Date ? value.toISOString() : value)
  if (search.fecha_creacion_start) params.created_from = toIso(search.fecha_creacion_start)
  if (search.fecha_creacion_end) params.created_to = toIso(search.fecha_creacion_end)
  if (search.fecha_modificacion_start) params.modified_from = toIso(search.fecha_modificacion_start)
  if (search.fecha_modificacion_end) params.modified_to = toIso(search.fecha_modificacion_end)
  if (search.page_token) params.page_token = search.page_token
  if (search.limit) params.limit = search.limit
  return params
}

// Traduce el usuario devuelto por la lambda (username/role) al formato que
// ya consume la tabla del front (nombre/rol), sin tocar UI ni traducciones.
const mapUserFromApi = (user) => ({
  nombre: user.username,
  email: user.email,
  rol: user.role,
  estado: user.estado,
  fecha_creacion: user.fecha_creacion,
  fecha_modificacion: user.fecha_modificacion,
})

export const useUsersReducer = () => {
  const [state, dispatch] = useReducer(UsersReducer, USERS_INITIAL_STATE)

  const { getUsers, getUsersStatusCount, requestUsersExport } = useUsersCalls()

  const getUsersTable = useCallback(
    (search) => {
      const config = { params: buildUsersQueryParams(search) }
      dispatch({ type: 'SET_LOADING' })
      getUsers(config)
        .then(({ data }) => {
          dispatch({
            type: 'SET_TABLE_DATA',
            payload: {
              data: (data?.users || []).map(mapUserFromApi),
              nextPageToken: data?.next_page_token,
              search: search,
            },
          })
        })
        .catch(() => {
          dispatch({ type: 'SET_FAILURE' })
        })
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const getStatusCount = useCallback(() => {
    dispatch({ type: 'SET_STATUS_COUNT_LOADING' })
    getUsersStatusCount()
      .then(({ data }) => {
        dispatch({ type: 'SET_STATUS_COUNT', payload: data })
      })
      .catch(() => {
        dispatch({ type: 'SET_STATUS_COUNT_FAILURE' })
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    ...state,
    dispatch,
    getUsersTable,
    getStatusCount,
    statusCountLoading: state.statusCountLoading,
    isLoading: state.loading || state.statusCountLoading,
    requestUsersExport,
  }
}
